import React, { createContext, useContext, useState, useCallback } from "react";

const DICT = {
  pt: {
    "nav.new": "Nova análise",
    "nav.analyses": "Análises",
    "nav.settings": "Configurações",
    "nav.user": "Usuário",
    "nav.logout": "Sair",
    "nav.users": "Usuários",
    "admin.title": "Usuários",
    "admin.subtitle": "Gerencie o acesso ao LEXADM.",
    "admin.name": "Nome",
    "admin.email": "E-mail",
    "admin.role": "Perfil",
    "admin.status": "Status",
    "admin.analyses": "Análises",
    "admin.created": "Cadastro",
    "admin.actions": "Ações",
    "admin.active": "Ativo",
    "admin.blocked": "Bloqueado",
    "admin.block": "Bloquear",
    "admin.unblock": "Desbloquear",
    "admin.you": "Você",
    "admin.blockTitle": "Bloquear usuário?",
    "admin.blockDesc": "O usuário perderá o acesso imediatamente e verá a tela de contato com o administrador.",
    "admin.unblockTitle": "Desbloquear usuário?",
    "admin.unblockDesc": "O usuário voltará a ter acesso completo ao sistema.",
    "admin.cancel": "Cancelar",
    "blocked.badge": "Acesso suspenso",
    "blocked.title": "Seu acesso ao LEXADM foi suspenso",
    "blocked.body": "Prezado(a) usuário(a), identificamos que o seu acesso à plataforma LEXADM encontra-se temporariamente suspenso por decisão do administrador do sistema. Para regularizar a sua situação e restabelecer o acesso, entre em contato diretamente com a administração através do canal oficial abaixo.",
    "blocked.whatsapp": "Falar com o administrador no WhatsApp",
    "blocked.logout": "Sair da conta",
    "blocked.footer": "LEXADM · Segurança e Integridade Documental",
    "dash.title": "Analise a integridade de um documento",
    "dash.subtitle":
      "Envie um PDF ou DOCX e identifique anomalias, conteúdo oculto e possíveis instruções direcionadas a sistemas de IA.",
    "dash.drop": "Arraste seu documento aqui",
    "dash.or": "ou",
    "dash.select": "Selecionar arquivo",
    "dash.accept": "Aceita PDF e DOCX · até 15 MB",
    "dash.recent": "Análises recentes",
    "stats.total": "Total analisado",
    "stats.high": "Alto risco",
    "stats.low": "Baixo risco",
    "stats.recent": "Análises recentes",
    "proc.title": "Analisando documento…",
    "proc.s1": "Integridade do arquivo",
    "proc.s2": "Estrutura",
    "proc.s3": "Formatação",
    "proc.s4": "Conteúdo oculto",
    "proc.s5": "Prompt injection",
    "proc.s6": "Metadados",
    "proc.s7": "Análise com IA",
    "res.title": "Risco do documento",
    "res.found": "anomalias encontradas",
    "res.viewFindings": "Ver achados",
    "res.download": "Baixar relatório",
    "res.findings": "Achados",
    "res.none": "Nenhuma anomalia relevante identificada.",
    "find.page": "Página",
    "find.snippet": "Trecho",
    "find.reason": "Motivo",
    "find.risk": "Risco",
    "find.viewDoc": "Ver no documento",
    "find.predominant": "Fonte predominante",
    "find.found": "Fonte encontrada",
    "viewer.document": "Documento",
    "viewer.panel": "Achado",
    "viewer.back": "Voltar ao resultado",
    "viewer.page": "Página",
    "hist.title": "Análises",
    "hist.document": "Documento",
    "hist.date": "Data",
    "hist.risk": "Risco",
    "hist.score": "Score",
    "hist.status": "Status",
    "hist.actions": "Ações",
    "hist.open": "Abrir",
    "hist.report": "Relatório",
    "hist.delete": "Excluir",
    "hist.empty": "Nenhuma análise ainda. Envie seu primeiro documento.",
    "set.title": "Configurações",
    "set.model": "Modelo de IA para confirmação",
    "set.modelHint": "Usado apenas para confirmar trechos suspeitos.",
    "set.lang": "Idioma",
    "set.account": "Conta",
    "login.tag": "Detecção inteligente de risco documental",
    "login.welcome": "Bem-vindo",
    "login.subtitle": "Acesse sua conta para analisar documentos.",
    "login.email": "E-mail",
    "login.password": "Senha",
    "login.name": "Nome",
    "login.signin": "Entrar",
    "login.signup": "Criar conta",
    "login.toRegister": "Não tem conta? Cadastre-se",
    "login.toLogin": "Já tem conta? Entrar",
    "common.loading": "Carregando…",
    "risk.BAIXO": "BAIXO RISCO",
    "risk.MEDIO": "MÉDIO RISCO",
    "risk.ALTO": "ALTO RISCO",
    "risk.CRITICO": "RISCO CRÍTICO",
  },
  en: {
    "nav.new": "New analysis",
    "nav.analyses": "Analyses",
    "nav.settings": "Settings",
    "nav.user": "User",
    "nav.logout": "Sign out",
    "nav.users": "Users",
    "admin.title": "Users",
    "admin.subtitle": "Manage access to LEXADM.",
    "admin.name": "Name",
    "admin.email": "Email",
    "admin.role": "Role",
    "admin.status": "Status",
    "admin.analyses": "Analyses",
    "admin.created": "Joined",
    "admin.actions": "Actions",
    "admin.active": "Active",
    "admin.blocked": "Blocked",
    "admin.block": "Block",
    "admin.unblock": "Unblock",
    "admin.you": "You",
    "admin.blockTitle": "Block user?",
    "admin.blockDesc": "The user will lose access immediately and see the administrator contact screen.",
    "admin.unblockTitle": "Unblock user?",
    "admin.unblockDesc": "The user will regain full access to the system.",
    "admin.cancel": "Cancel",
    "blocked.badge": "Access suspended",
    "blocked.title": "Your access to LEXADM has been suspended",
    "blocked.body": "Dear user, we have identified that your access to the LEXADM platform is temporarily suspended by decision of the system administrator. To resolve your situation and restore access, please contact the administration directly through the official channel below.",
    "blocked.whatsapp": "Contact the administrator on WhatsApp",
    "blocked.logout": "Sign out",
    "blocked.footer": "LEXADM · Document Security & Integrity",
    "dash.title": "Analyze a document's integrity",
    "dash.subtitle":
      "Upload a PDF or DOCX and detect anomalies, hidden content and possible instructions aimed at AI systems.",
    "dash.drop": "Drag your document here",
    "dash.or": "or",
    "dash.select": "Select file",
    "dash.accept": "Accepts PDF and DOCX · up to 15 MB",
    "dash.recent": "Recent analyses",
    "stats.total": "Total analyzed",
    "stats.high": "High risk",
    "stats.low": "Low risk",
    "stats.recent": "Recent analyses",
    "proc.title": "Analyzing document…",
    "proc.s1": "File integrity",
    "proc.s2": "Structure",
    "proc.s3": "Formatting",
    "proc.s4": "Hidden content",
    "proc.s5": "Prompt injection",
    "proc.s6": "Metadata",
    "proc.s7": "AI analysis",
    "res.title": "Document risk",
    "res.found": "anomalies found",
    "res.viewFindings": "View findings",
    "res.download": "Download report",
    "res.findings": "Findings",
    "res.none": "No relevant anomalies identified.",
    "find.page": "Page",
    "find.snippet": "Excerpt",
    "find.reason": "Reason",
    "find.risk": "Risk",
    "find.viewDoc": "View in document",
    "find.predominant": "Predominant font",
    "find.found": "Found font",
    "viewer.document": "Document",
    "viewer.panel": "Finding",
    "viewer.back": "Back to result",
    "viewer.page": "Page",
    "hist.title": "Analyses",
    "hist.document": "Document",
    "hist.date": "Date",
    "hist.risk": "Risk",
    "hist.score": "Score",
    "hist.status": "Status",
    "hist.actions": "Actions",
    "hist.open": "Open",
    "hist.report": "Report",
    "hist.delete": "Delete",
    "hist.empty": "No analyses yet. Upload your first document.",
    "set.title": "Settings",
    "set.model": "AI model for confirmation",
    "set.modelHint": "Used only to confirm suspicious excerpts.",
    "set.lang": "Language",
    "set.account": "Account",
    "login.tag": "Intelligent document risk detection",
    "login.welcome": "Welcome",
    "login.subtitle": "Sign in to analyze your documents.",
    "login.email": "Email",
    "login.password": "Password",
    "login.name": "Name",
    "login.signin": "Sign in",
    "login.signup": "Create account",
    "login.toRegister": "No account? Sign up",
    "login.toLogin": "Have an account? Sign in",
    "common.loading": "Loading…",
    "risk.BAIXO": "LOW RISK",
    "risk.MEDIO": "MEDIUM RISK",
    "risk.ALTO": "HIGH RISK",
    "risk.CRITICO": "CRITICAL RISK",
  },
};

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(localStorage.getItem("lexadm_lang") || "pt");
  const setLang = useCallback((l) => {
    localStorage.setItem("lexadm_lang", l);
    setLangState(l);
  }, []);
  const t = useCallback((key) => DICT[lang][key] || DICT.pt[key] || key, [lang]);
  return (
    <I18nContext.Provider value={{ lang, setLang, t }}>{children}</I18nContext.Provider>
  );
}

export function useI18n() {
  return useContext(I18nContext);
}
